import { useCallback, useMemo } from "react";

import { useFlags } from "components/FeatureFlag/useFlags";

export function useFetchWithStats(fetchFn) {
  const { loadingConfig, flags } = useFlags();

  const defaultStats = useMemo(() => {
    return { includeProcessStats: false, includeViewStats: false };
  }, []);

  return useCallback(
    async (params) => {
      if (loadingConfig) return new Promise(() => {});

      if ("process-and-views-stats" in flags) {
        return fetchFn({ ...params, ...flags["process-and-views-stats"] });
      }

      return fetchFn({ ...params, ...defaultStats });
    },
    [flags, loadingConfig, fetchFn, defaultStats]
  );
}

export default useFetchWithStats;
